





















































































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import dayjs from 'dayjs';
import moment from 'moment'
import { WarehouseLocationServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { MaterialCollectionRecordServiceProxy, PlanMaterialServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies';
const pmsp = new PlanMaterialServiceProxy()
const whlsp = new WarehouseLocationServiceProxy()
const mcrsp = new MaterialCollectionRecordServiceProxy()

const columns = [
  {
    title: '物料编号',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: '物料名称',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: '需求数量',
    dataIndex: 'requireNum',
    scopedSlots: { customRender: 'requireNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: '实际需求',
    dataIndex: 'realRequireNum',
    scopedSlots: { customRender: 'realRequireNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: '配领人员',
    dataIndex: 'customer',
    scopedSlots: { customRender: 'customer' },
    ellipsis: true,
    width: 150
  },
  {
    title: '库区',
    dataIndex: 'area',
    scopedSlots: { customRender: 'area' },
    ellipsis: true,
    width: 150
  },
  {
    title: '库位',
    dataIndex: 'location',
    ellipsis: true,
    scopedSlots: { customRender: 'location' },
    width: 150
  },
  {
    title: '需求状态',
    dataIndex: 'requireStatus',
    ellipsis: true,
    scopedSlots: { customRender: 'requireStatus' },
    width: 150
  }
]
const statusList = [
  {
    key: 0,
    value: '待出库'
  },
  {
    key: 1,
    value: '配料中'
  },
  {
    key: 2,
    value: '完成'
  },
  {
    key: 3,
    value: '关闭'
  },
  {
    key: 4,
    value: '重启'
  }
]
export default Vue.extend({
  data(){
    return {
      form: this.$form.createForm(this),
      dataSource: [],
      cacheData: [],
      locationList: [], // 库位列表
      loading: false,
      statusList
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    allAreaList:{
      type: Array,
      default: () => ([])
    },
    employeesList:{
      type: Array,
      default: () => ([])
    },
    plan:{
      type: Object,
      default: () => ({})
    }
  },
  watch:{
    visible:{
      handler(){
        if(this.visible){
          this.dataSource = []
          console.log(this.plan)
          pmsp.materialList("",this.plan.id).then(res =>{
            this.dataSource = this.review(res)
            this.cacheData = this.dataSource
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  methods:{
    dayFormat(time){
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    findStatus(value){
      const data = this.statusList.find(res => res.key == value)
      return (data ? data.value : "")
    },
    review(res){
      const data = []
      if(res && res.length > 0){
        res.forEach((item,index) => {
          const value = {
            key: index,
            area: item.area,
            customer: item.acceptedPerson,
            id: item.id,
            location: item.location,
            materialCode: item.materialCode,
            materialName: item.materialName,
            realRequireNum: 0,
            requireNum: item.requireNum,
            requireStatus: item.requireStatus
          }
          data.push(value)
        });
      }
      return data
    },
    handleChange(value, record, column) {
      const newData = [...this.dataSource];
      const target = newData.filter(item => record.key === item.key)[0];
      if (target) {
        target[column] = value;
        this.dataSource = newData;
      }
    },
    close(){
      this.form.resetFields()
      this.dataSource = []
      this.cacheData = []
      this.$emit('close')
    },
    save(){
      if(this.dataSource && this.dataSource.length > 0){
        this.loading = true
        const list = []
        this.dataSource.forEach(element => {
          if((element.realRequireNum !== undefined || element.realRequireNum !== null) && element.realRequireNum > 0){
            delete element.key
            list.push(element)
          }  
        });
        pmsp.updateMaterialRequireNum(list).then(() =>{
          this.form.resetFields()
          this.dataSource = []
          this.cacheData = []
          this.$emit('reload')
          this.loading = false
          this.$message.success(this.$t('save_success'))
        }).catch(() =>{
          this.loading = false
        })
      }
    }
  }
})

